// extracted by mini-css-extract-plugin
export default {"MasterFrase":"frase_MasterFrase__b0sjM","Frasebanner":"frase_Frasebanner__XAHLT","Frase":"frase_Frase__jaes5","FraseDestacada":"frase_FraseDestacada__Slw5l"};